import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

const ClearButton = ({visible, onClick, hoverText}) => {
  return visible ? (
    <IconButton 
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      className={"ClearButton-root"}
    >
      <Tooltip title={hoverText} placement={"top"}>
        <svg 
          className={"ClearButton-svg"}
          viewBox={"0 0 20 20"}
          aria-hidden={true}
          focusable={false}
        >
          <path  d={"M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"}/>
        </svg>
      </Tooltip>
    </IconButton>
  ) : null;
};

ClearButton.defaultProps = {
  visible: true,
  onClick: () => {},
  hoverText: "",
};

ClearButton.propTypes = {
  //If true the component will be rendered
  visible: PropTypes.bool,
  //What the Button does onClick
  onClick: PropTypes.func,
  //Optional text to display when hovering over button
  hoverText: PropTypes.string,
};

export default ClearButton;